import { DeclineRiskDecisionCode } from './risk-decision-codes';

export const OFAC_BLOCKED_RISK_DECISION_CODE_IDS = [
  DeclineRiskDecisionCode.OFAC_BLOCK,
  DeclineRiskDecisionCode.OFAC_REJECT
];
export const OFAC_DISABLE_REASON = 'Under Sanctions review \u2013 SLOD only';
